import { i18nMark } from 'lingui-react';

const formattedMessages = {
  title: i18nMark('Complaint'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./compositions/ComplaintWidget/messages.js